export const getSessionIdConfig = (appConfig) => {
	return appConfig?.sessionId
		? {
				sessionId: appConfig?.sessionId,
		  }
		: {};
};
